import { render, staticRenderFns } from "./addCoach.vue?vue&type=template&id=18dde1be&"
import script from "./addCoach.vue?vue&type=script&lang=js&"
export * from "./addCoach.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\drone_race_manage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18dde1be')) {
      api.createRecord('18dde1be', component.options)
    } else {
      api.reload('18dde1be', component.options)
    }
    module.hot.accept("./addCoach.vue?vue&type=template&id=18dde1be&", function () {
      api.rerender('18dde1be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/auth/users/components/addCoach.vue"
export default component.exports